import { timeout } from '../../../shared/lib/timeout.no-deps'
import { Auth_redirectReceived } from '../Auth/Auth.redirect'
import { Auth_loginSync } from '../Auth/Auth.loginSync'
import { Auth_safeLogout } from '../Auth/Auth.logout'
import { hideSafariViewController } from '../Auth/Auth.SafariViewController'
import { Auth_syncRequired } from '../Auth/Auth.State'
import type { Base_Bus } from '../Base/Base.Bus'
import { DS_getData, DS_setData } from '../DS/DS.Data'
import { Auth_navigateLogin } from '../Auth/Auth.navigate'
import { User_get } from '../User/User.get'

//
// This is triggered when a browser opens a url that starts with zaptic://
// Typically this will be the redirect from the login
//
export async function Evnt_handleOpenURL(urlString: string, bus: Base_Bus) {
    // This is to stop crashing on iphones
    // Not sure the cause but it throws a EXC_BREAKPOINT error in the native code
    // This seems to avoid the issue for some reason
    await timeout(0)

    if (urlString.startsWith(`${ENV.customUrlScheme}://callback`)) {
        await hideSafariViewController()
        await Auth_redirectReceived(urlString)

        if (Auth_syncRequired()) {
            await Auth_loginSync(bus)
        }
    }

    if (urlString.startsWith(`${ENV.customUrlScheme}://login`)) {
        await hideSafariViewController()

        const url = new URL(urlString)
        const email = url.searchParams.get('email')
        const password = url.searchParams.get('password')
        const user = User_get()

        // If already logged in as that user, ignore request to login again
        if (user != null && user.email === email) return

        DS_setData('AutomaticLoginRequested', () => ({
            auth: { status: 'pending-automatic-login', email, password },
        }))

        // If already loaded, login again with new credentials
        if (DS_getData().onLoad.status === 'success') {
            await Auth_safeLogout()
            Auth_navigateLogin()
        }
    }
}
